import { render, staticRenderFns } from "./FileImageOutline.vue?vue&type=template&id=56c8b5b0"
import script from "./FileImageOutline.vue?vue&type=script&lang=js"
export * from "./FileImageOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports